export default "__VITE_ASSET__BO2F2v6R__"